// extracted by mini-css-extract-plugin
module.exports = {"taskItem":"Task_taskItem__2p4n1","taskControls":"Task_taskControls__3O1mi"};